import { openContactForm } from "../../Functions/contactFormFunctions";
import "./style.scss";

const OpenContactFormButton: React.FC = () => {
    /* Fixed button made for the user to open the contact form */
    return(
        <div onClick={() => openContactForm()} className="contactButton flexDisplay">
            <span onClick={() => openContactForm()} className="material-symbols-outlined">chat</span>
        </div>
    )
}

export default OpenContactFormButton;
